import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { LoaderModule } from './loader/loader.module';
import { NotificationComponent } from './notification.component';
import { NotificationService } from './notification.service';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';

@NgModule({
  declarations: [NotificationComponent],
  imports: [CommonModule, LoaderModule, MatDialogModule, MatSnackBarModule],
  exports: [NotificationComponent],
  providers: [NotificationService]
})
export class NotificationModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: NotificationModule,
      providers: [NotificationService]
    };
  }
}
